<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid whopperco-container">
      <div class="row window-height">

        <!-- LEFT: Sign In Form -->
        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-3 p-md-4">

            <!-- BK Logo -->
            <div class="text-center mb-3 anim-fade-in" style="animation-delay: 0.1s">
              <img src="/signup-img/whopperco/bk-logo.png" alt="Burger King" class="bk-logo" />
            </div>

            <!-- Whopperco wordmark -->
            <div class="text-center mb-3 anim-fade-in" style="animation-delay: 0.2s">
              <p class="whopperco-wordmark mb-0">WHOPPERCO</p>
              <p class="whopperco-tagline">Franchise Training Portal</p>
            </div>

            <!-- Form heading -->
            <div class="signin-header anim-slide-up" style="animation-delay: 0.3s">
              <h3 class="mb-0">Sign In <img src="/signup-img/fire.svg" alt="" /></h3>
              <span class="d-block mb-4">Use your employee ID and date of birth.</span>
            </div>

            <form role="form" @submit.prevent="onSubmit" novalidate class="anim-slide-up" style="animation-delay: 0.4s">
              <div class="mb-3">
                <input
                  v-model="form.employeeId"
                  type="text"
                  inputmode="numeric"
                  autocomplete="username"
                  placeholder="Employee ID"
                  class="form-control login-input singup-input"
                />
              </div>

              <div class="pass-wrap position-relative mb-3">
                <input
                  v-model="form.password"
                  :type="passwordFieldType"
                  autocomplete="current-password"
                  placeholder="Password (default: MMDDYYYY)"
                  class="form-control login-input singup-input"
                />
                <span class="eye-icon-pass" @click="togglePassword">
                  <svg v-if="passwordFieldType === 'password'" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.2 4.2M9.5 5.4A11 11 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.4 4.4M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7c1.6 0 3-.3 4.3-.8" />
                  </svg>
                  <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
                    <circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
              </div>

              <div class="row my-4">
                <div class="col-6">
                  <label class="chk-container">Remember me
                    <input type="checkbox" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="col-6">
                  <div class="text-right forget-txt">
                    <router-link to="/forgot_password">Forgot Password?</router-link>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center signinbtn mb-3">
                <button type="submit" class="btn d-block w-100" :disabled="loading">
                  <span v-if="!loading">Sign In</span>
                  <span v-else>Signing in…</span>
                  <svg v-if="!loading" width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5467 10.9333C17.2401 10.5333 16.8667 10.1867 16.5201 9.84C15.6267 9.04 14.6134 8.46667 13.7601 7.62667C11.7734 5.68 11.3334 2.46667 12.6001 0C11.3334 0.306667 10.2267 1 9.28007 1.76C5.82673 4.53333 4.46673 9.42667 6.0934 13.6267C6.14673 13.76 6.20007 13.8933 6.20007 14.0667C6.20007 14.36 6.00007 14.6267 5.7334 14.7333C5.42673 14.8667 5.10673 14.7867 4.8534 14.5733C4.77773 14.5099 4.71444 14.4331 4.66673 14.3467C3.16007 12.44 2.92007 9.70667 3.9334 7.52C1.70673 9.33333 0.4934 12.4 0.666733 15.2933C0.746733 15.96 0.826733 16.6267 1.0534 17.2933C1.24007 18.0933 1.60007 18.8933 2.00007 19.6C3.44007 21.9067 5.9334 23.56 8.6134 23.8933C11.4667 24.2533 14.5201 23.7333 16.7067 21.76C19.1467 19.5467 20.0001 16 18.7467 12.96L18.5734 12.6133C18.2934 12 17.5467 10.9333 17.5467 10.9333ZM13.3334 19.3333C12.9601 19.6533 12.3467 20 11.8667 20.1333C10.3734 20.6667 8.88007 19.92 8.00007 19.04C9.58673 18.6667 10.5334 17.4933 10.8134 16.3067C11.0401 15.24 10.6134 14.36 10.4401 13.3333C10.2801 12.3467 10.3067 11.5067 10.6667 10.5867C10.9201 11.0933 11.1867 11.6 11.5067 12C12.5334 13.3333 14.1467 13.92 14.4934 15.7333C14.5467 15.92 14.5734 16.1067 14.5734 16.3067C14.6134 17.4 14.1334 18.6 13.3334 19.3333Z" fill="white" />
                  </svg>
                </button>
              </div>

              <div class="docebo-divider"><span>or</span></div>

              <button type="button" class="btn-docebo" :disabled="doceboLoading" @click="onDoceboSso">
                <span v-if="!doceboLoading"><span class="d-icon">D</span> Continue with Docebo SSO</span>
                <span v-else>Connecting to Docebo…</span>
              </button>

              <p class="signin-link text-center mb-0 mt-4">
                Need an account?
                <router-link to="/register" class="font-weight-bold">Request Access</router-link>
              </p>

              <p class="error" v-if="error">{{ error }}</p>
            </form>

            <!-- HOT logo footer -->
            <div class="text-center mt-3 anim-fade-in" style="animation-delay: 0.7s">
              <img src="/signup-img/whopperco/hot-logo.png" alt="Home of Training" class="hot-logo" />
            </div>
          </div>
        </div>

        <!-- RIGHT: Hero Panel -->
        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-4 pl-2 pl-md-5 pr-2 pr-md-5">
            <div class="hot-logo-badge anim-fade-in" style="animation-delay: 0.2s">
              <img src="/signup-img/whopperco/hot-logo.png" alt="Home of Training" class="hot-logo-hero" />
            </div>
            <h2 class="text-white mb-2 anim-slide-up" style="animation-delay: 0.3s">
              Train every Whopperco team. Everywhere.
            </h2>
            <p class="text-white mb-3 anim-slide-up" style="animation-delay: 0.45s">
              160 locations. One franchise training platform. Compliance, food safety, customer service — all in one place.
            </p>

            <div class="img-wrap anim-float-in">
              <img class="img-fluid dashboard-img" src="/signup-img/admin-img.webp" alt="Whopperco dashboard preview" />
            </div>

            <div class="stat-row anim-slide-up mt-auto pb-4" style="animation-delay: 0.55s">
              <div class="stat">
                <span class="stat-num">160</span>
                <span class="stat-label">Franchise locations</span>
              </div>
              <div class="stat">
                <span class="stat-num">12</span>
                <span class="stat-label">BK courses live</span>
              </div>
              <div class="stat">
                <span class="stat-num">100%</span>
                <span class="stat-label">Mobile-ready</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Docebo OAuth popup (mocked) -->
    <div v-if="doceboModalOpen" class="docebo-modal-backdrop" @click.self="closeDoceboModal">
      <div class="docebo-modal" role="dialog" aria-labelledby="docebo-title">
        <button class="docebo-close" @click="closeDoceboModal" aria-label="Close">×</button>
        <div class="docebo-header">
          <div class="docebo-brand">
            <span class="docebo-logo">D</span>
            <span class="docebo-brand-text">docebo</span>
          </div>
          <p class="docebo-context">
            <strong>Whopperco</strong> wants to access your Docebo Learn account.
          </p>
        </div>
        <div class="docebo-body">
          <p class="docebo-instruction">Sign in to authorize this connection. Your credentials go to Docebo — Whopperco never sees them.</p>
          <form @submit.prevent="onDoceboAuthorize" novalidate>
            <div class="docebo-field">
              <label for="docebo-email">Docebo email</label>
              <input id="docebo-email" type="email" v-model="docebo.email" autocomplete="username" placeholder="you@whopperco.com" required />
            </div>
            <div class="docebo-field">
              <label for="docebo-password">Password</label>
              <input id="docebo-password" type="password" v-model="docebo.password" autocomplete="current-password" placeholder="••••••••" required />
            </div>
            <label class="docebo-remember">
              <input type="checkbox" v-model="docebo.remember" />
              <span>Stay signed in for 90 days on this device</span>
            </label>
            <p v-if="docebo.error" class="docebo-error">{{ docebo.error }}</p>
            <div class="docebo-actions">
              <button type="button" class="docebo-btn-secondary" @click="closeDoceboModal">Cancel</button>
              <button type="submit" class="docebo-btn-primary" :disabled="docebo.loading">
                <span v-if="!docebo.loading">Authorize Whopperco →</span>
                <span v-else>Authorizing…</span>
              </button>
            </div>
          </form>
          <div class="docebo-scopes">
            <p class="docebo-scopes-title">Whopperco will be able to:</p>
            <ul>
              <li>✓ Read your enrolled course list and progress</li>
              <li>✓ Issue and store training certificates on your behalf</li>
              <li>✓ Sync your franchise location and role</li>
            </ul>
          </div>
        </div>
        <p class="docebo-footer">Powered by Docebo Learn · <a href="#" @click.prevent>Privacy</a> · <a href="#" @click.prevent>Terms</a></p>
      </div>
    </div>
  </div>
</template>

<script>
const DOCEBO_KEY = 'whopperco.docebo.session';

export default {
  name: 'WhopperLogin',
  data() {
    return {
      form: { employeeId: '', password: '' },
      passwordFieldType: 'password',
      loading: false,
      doceboLoading: false,
      doceboModalOpen: false,
      docebo: {
        email: '',
        password: '',
        remember: true,
        loading: false,
        error: '',
      },
      error: '',
      year: new Date().getFullYear(),
    };
  },
  mounted() {
    // Auto-route on existing 90-day Docebo session
    try {
      const raw = localStorage.getItem(DOCEBO_KEY);
      if (!raw) return;
      const sess = JSON.parse(raw);
      if (sess && sess.expiresAt && Date.now() < sess.expiresAt) {
        // valid Docebo session → straight to dashboard (SSO skips change-password)
        this.$router.replace('/whopperco/dashboard');
      } else if (sess) {
        // expired — clear it
        localStorage.removeItem(DOCEBO_KEY);
      }
    } catch (e) { /* ignore malformed session */ }
  },
  methods: {
    togglePassword() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      this.error = '';
      if (!this.form.employeeId || !this.form.password) {
        this.error = 'Both employee ID and password are required.';
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        // Employee-ID flow still hits the first-login change-password screen
        this.$router.push('/whopperco/change-password');
      }, 900);
    },
    onDoceboSso() {
      // Open the mocked Docebo OAuth popup
      this.doceboModalOpen = true;
      this.docebo.error = '';
    },
    closeDoceboModal() {
      this.doceboModalOpen = false;
      this.docebo.loading = false;
    },
    onDoceboAuthorize() {
      this.docebo.error = '';
      if (!this.docebo.email || !this.docebo.password) {
        this.docebo.error = 'Docebo email and password are required.';
        return;
      }
      this.docebo.loading = true;
      // Mocked OAuth round-trip
      setTimeout(() => {
        const session = {
          provider: 'docebo',
          email: this.docebo.email,
          name: this.deriveName(this.docebo.email),
          issuedAt: Date.now(),
          expiresAt: Date.now() + (this.docebo.remember ? 90 : 1) * 24 * 60 * 60 * 1000,
        };
        try { localStorage.setItem(DOCEBO_KEY, JSON.stringify(session)); } catch (e) { /* ignore */ }
        this.docebo.loading = false;
        this.doceboModalOpen = false;
        // SSO bypasses change-password — Docebo handles credentials
        this.$router.push('/whopperco/dashboard');
      }, 1100);
    },
    deriveName(email) {
      const local = (email || '').split('@')[0] || '';
      return local
        .replace(/[._-]+/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase()) || 'Whopperco User';
    },
  },
};
</script>

<style scoped>
html, body, .window-height {
  min-height: 100vh;
}

.whopperco-container {
  font-family: "Inter", "Nunito", sans-serif;
  color: #1e1e1e;
}

/* ===== Left Panel ===== */
.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;
  background-size: contain;
  display: flex;
  align-items: flex-start;
  padding-top: 3vh;
  min-height: 100vh;
}

.inner-left-wrap {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
}

.bk-logo {
  max-width: 78px;
  height: auto;
}

.whopperco-wordmark {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 4px;
  color: #502314;
  line-height: 1.1;
  margin: 0;
}

.whopperco-tagline {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 3px 0 0;
}

.signin-header h3 {
  font-size: 26px;
  font-weight: 700;
  color: #1e1e1e;
  line-height: 1.2;
  margin-bottom: 2px;
}

.signin-header h3 img {
  margin-left: 4px;
  vertical-align: middle;
  height: 24px;
}

.signin-header span {
  font-size: 13px;
  color: #6b7280;
}

.singup-input {
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  height: auto;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.singup-input:focus {
  outline: none;
  border-color: #ea2628;
  box-shadow: 0 0 0 4px rgba(234, 38, 40, 0.1);
}

.pass-wrap .eye-icon-pass {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}

.chk-container {
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
}

.forget-txt a {
  font-size: 13px;
  color: #ea2628;
  font-weight: 600;
  text-decoration: none;
}

.forget-txt a:hover { text-decoration: underline; }

/* Button — same orange→red as production HOT login */
.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  letter-spacing: 0.3px;
  transition: opacity 0.2s, transform 0.15s;
}

.signinbtn .btn:hover { opacity: 0.92; }
.signinbtn .btn:active { transform: translateY(1px); }
.signinbtn .btn:disabled { opacity: 0.6; cursor: not-allowed; }

.docebo-divider {
  position: relative;
  text-align: center;
  margin: 14px 0 10px;
  color: #9ca3af;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.docebo-divider::before,
.docebo-divider::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 42%;
  height: 1px;
  background: #e5e7eb;
}

.docebo-divider::before { left: 0; }
.docebo-divider::after { right: 0; }
.docebo-divider span { background: #f3f3f3; padding: 0 8px; position: relative; z-index: 1; }

.btn-docebo {
  background: #fff;
  color: #1e1e1e;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  width: 100%;
}

.btn-docebo:hover {
  border-color: #502314;
  background: #fafafa;
}

.btn-docebo:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-docebo .d-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #ea2628;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 800;
}

.signin-link {
  font-size: 14px;
  color: #6b7280;
}

.signin-link a {
  color: #ea2628;
}

.hot-logo {
  max-width: 80px;
  height: auto;
  opacity: 0.7;
}

.error {
  color: #ea2628;
  text-align: center;
  font-size: 13px;
  margin-top: 12px;
}

/* ===== Right Panel ===== */
.right-bg {
  background:
    radial-gradient(circle at 20% 20%, rgba(255, 209, 92, 0.18) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(0, 0, 0, 0.25) 0%, transparent 60%),
    linear-gradient(135deg, #ea2628 0%, #c01618 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.right-bg::before {
  content: "";
  position: absolute;
  top: -120px;
  right: -120px;
  width: 380px;
  height: 380px;
  background: radial-gradient(circle, rgba(255, 209, 92, 0.35) 0%, transparent 65%);
  filter: blur(40px);
  pointer-events: none;
}

/* Real-color HOT logo on a white badge card so the colors stay legible on red bg */
.hot-logo-badge {
  background: #fff;
  display: inline-block;
  padding: 14px 24px;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  align-self: flex-start;
  margin-bottom: 18px;
}
.hot-logo-hero {
  max-width: 170px;
  height: auto;
  display: block;
}

.inner-right-wrap {
  position: relative;
  z-index: 1;
}

.inner-right-wrap h2 {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.5px;
}

.inner-right-wrap p {
  font-size: 15px;
  max-width: 88%;
  opacity: 0.92;
  line-height: 1.45;
}

.stat-row {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.stat {
  display: flex;
  flex-direction: column;
  color: #fff;
}

.stat-num {
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
  color: #ffd15c;
}

.stat-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 4px;
  opacity: 0.85;
}

.img-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 4px 0 18px;
}

.dashboard-img {
  width: 100%;
  max-width: 380px;
  max-height: 30vh;
  object-fit: contain;
  animation: gentleFloat 4s ease-in-out 1.5s infinite;
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);
}

/* ===== Animations ===== */
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
@keyframes floatIn { from { opacity: 0; transform: translateX(40px) translateY(20px); } to { opacity: 1; transform: translateX(0) translateY(0); } }
@keyframes gentleFloat { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
@keyframes btnGlow { 0%, 100% { box-shadow: 0 0 0 0 rgba(228, 142, 57, 0); } 50% { box-shadow: 0 0 24px 5px rgba(234, 38, 40, 0.28); } }

.anim-fade-in { opacity: 0; animation: fadeIn 0.6s ease-out forwards; }
.anim-slide-up { opacity: 0; animation: slideUp 0.6s ease-out forwards; }
.anim-float-in { opacity: 0; animation: floatIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.5s forwards; }

.signinbtn .btn { animation: btnGlow 2.5s ease-in-out 1s infinite; }

@media (max-width: 768px) {
  .right-bg { padding: 32px 16px; min-height: auto; }
  .inner-right-wrap h2 { font-size: 24px; }
  .stat-row { gap: 18px; }
  .stat-num { font-size: 22px; }
  .img-wrap { display: none !important; }
}

/* ===== Docebo OAuth modal ===== */
.docebo-modal-backdrop {
  position: fixed; inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
  display: flex; align-items: center; justify-content: center;
  z-index: 200; padding: 16px;
  animation: doceboFade 0.18s ease-out;
}
@keyframes doceboFade { from { opacity: 0; } to { opacity: 1; } }

.docebo-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 460px;
  width: 100%;
  box-shadow: 0 28px 72px rgba(0, 0, 0, 0.4);
  animation: doceboRise 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}
@keyframes doceboRise {
  from { opacity: 0; transform: translateY(20px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.docebo-close {
  position: absolute; top: 12px; right: 12px;
  background: rgba(255, 255, 255, 0.9); border: 0;
  width: 30px; height: 30px; border-radius: 999px;
  font-size: 22px; color: #1e1e1e; line-height: 1;
  cursor: pointer; z-index: 2;
}
.docebo-close:hover { background: #fff; }

.docebo-header {
  background: linear-gradient(135deg, #0066ff 0%, #4f46e5 100%);
  color: #fff;
  padding: 22px 26px 18px;
}
.docebo-brand {
  display: flex; align-items: center; gap: 10px;
  margin-bottom: 8px;
}
.docebo-logo {
  width: 30px; height: 30px; border-radius: 6px;
  background: #fff; color: #0066ff;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 18px; font-weight: 800;
}
.docebo-brand-text {
  font-size: 18px; font-weight: 800; letter-spacing: -0.5px;
}
.docebo-context {
  margin: 0; font-size: 13px; opacity: 0.94;
}
.docebo-context strong { font-weight: 700; }

.docebo-body {
  padding: 22px 26px 18px;
}
.docebo-instruction {
  font-size: 12px; color: #6b7280;
  margin: 0 0 16px;
}

.docebo-field {
  margin-bottom: 12px;
}
.docebo-field label {
  display: block; font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.5px;
  color: #6b7280; margin-bottom: 5px;
}
.docebo-field input {
  width: 100%;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px;
  color: #1e1e1e;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.docebo-field input:focus {
  outline: 0; border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 102, 255, 0.1);
}

.docebo-remember {
  display: flex; align-items: center; gap: 8px;
  margin: 14px 0 6px;
  font-size: 12px; color: #4b5563;
  cursor: pointer;
}
.docebo-remember input { margin: 0; }

.docebo-error {
  background: #fef2f2; color: #b91c1c;
  border-left: 3px solid #ef4444;
  padding: 8px 12px; border-radius: 6px;
  font-size: 12px; font-weight: 600;
  margin: 10px 0 0;
}

.docebo-actions {
  display: flex; gap: 8px; justify-content: flex-end;
  margin-top: 14px;
}
.docebo-btn-secondary, .docebo-btn-primary {
  border: 0; padding: 10px 16px; border-radius: 8px;
  font-size: 13px; font-weight: 700; cursor: pointer;
  transition: opacity 0.15s, background 0.15s;
}
.docebo-btn-secondary {
  background: #f3f4f6; color: #4b5563;
}
.docebo-btn-secondary:hover { background: #e5e7eb; }
.docebo-btn-primary {
  background: linear-gradient(135deg, #0066ff 0%, #4f46e5 100%);
  color: #fff;
}
.docebo-btn-primary:hover { opacity: 0.92; }
.docebo-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

.docebo-scopes {
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  padding: 12px 14px;
  margin-top: 18px;
}
.docebo-scopes-title {
  font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.5px;
  color: #6b7280; margin: 0 0 6px;
}
.docebo-scopes ul {
  margin: 0; padding: 0; list-style: none;
  font-size: 12px; color: #4b5563;
}
.docebo-scopes li {
  padding: 2px 0;
}

.docebo-footer {
  font-size: 10px; text-align: center; color: #9ca3af;
  padding: 10px 26px 18px;
  margin: 0;
}
.docebo-footer a { color: #6b7280; text-decoration: none; }
.docebo-footer a:hover { text-decoration: underline; }
</style>
